export default {
  previewSize: () => '250x155',
};
